'use es6';

import * as AttributesApi from '../api/attributes';
import { getHasSeenWelcomeTab, getHasUserOnboarded, getShowStarterDowngradeNotice } from 'DesignData/selectors/onboarding';
import { without } from 'underscore';
import { ONBOARDING_DATA_POST } from 'DesignData/actions/ActionTypes';
/*
 * POST /users/v1/attributes
 */

function createUpdateAction(valueBuilder, retries = 5, delay = 500) {
  return () => {
    const {
      request,
      receive,
      error
    } = createUpdateAction;
    return (dispatch, getState) => {
      const state = getState();
      const onboardingData = valueBuilder(state);
      dispatch(request());
      return AttributesApi.saveOnboardingSettings(onboardingData).then(attributes => {
        dispatch(receive(attributes));
      }).catch(__error => {
        if (retries > 0) {
          setTimeout(() => {
            dispatch(createUpdateAction(valueBuilder, retries - 1, delay * 2)());
          }, delay);
        } else {
          dispatch(error(__error));
        }
      });
    };
  };
}

createUpdateAction.request = () => {
  return {
    type: ONBOARDING_DATA_POST
  };
};

createUpdateAction.receive = attributes => {
  return {
    type: ONBOARDING_DATA_POST,
    attributes
  };
};

createUpdateAction.error = error => {
  return {
    type: ONBOARDING_DATA_POST,
    error
  };
};

export const setUserWelcomeTabStatus = status => createUpdateAction(state => {
  return {
    hasUsedCos: true,
    hasSeenWelcomeTab: status,
    hasOnboardedIDE: getHasUserOnboarded(state),
    showStarterDowngradeNotice: getShowStarterDowngradeNotice(state)
  };
});
export const toggleShouldShowStarterDowngradeNotice = createUpdateAction(state => {
  let showStarterDowngradeNotice = getShowStarterDowngradeNotice(state);
  const portalId = state.auth.portal.portal_id;

  if (showStarterDowngradeNotice.includes(portalId)) {
    showStarterDowngradeNotice = without(showStarterDowngradeNotice, portalId);
  } else {
    showStarterDowngradeNotice.push(portalId);
  }

  return {
    hasOnboardedIDE: getHasUserOnboarded(state),
    hasSeenWelcomeTab: getHasSeenWelcomeTab(state),
    hasUsedCos: true,
    showStarterDowngradeNotice
  };
});